<div class="toolbar">
  <ng-content select="[toolbar]"></ng-content>
</div>

<div
  class="organization-grid"
  [class.organization-grid-compact]="!isPlatformAdmin"
>
  <div class="grid-group">
    <markant-platform-ui-card
      class="grid-item"
      [headline]="'organization.details.masterdata' | transloco"
    >
      <markant-platform-ui-card-item
        [label]="'organization.details.fields.name.label' | transloco"
        [title]="organization.name"
      >
        {{ organization.name }}
      </markant-platform-ui-card-item>
      <markant-platform-ui-card-item
        [label]="'organization.details.fields.contactPhone.label' | transloco"
        [title]="organization.phone"
      >
        {{ organization.phone | defaultValue: '-' }}
      </markant-platform-ui-card-item>

      <markant-seperator></markant-seperator>

      <markant-platform-ui-card-item
        *ngIf="organization.salesTaxId; else taxNumber"
        [label]="'organization.details.fields.salesTaxId.label' | transloco"
        [title]="organization.salesTaxId"
      >
        {{ organization.salesTaxId | defaultValue: '-' }}
      </markant-platform-ui-card-item>
      <ng-template #taxNumber>
        <markant-platform-ui-card-item
          [label]="'organization.details.fields.taxNumber.label' | transloco"
          [title]="organization.taxNumber"
        >
          {{ organization.taxNumber | defaultValue: '-' }}
        </markant-platform-ui-card-item>
      </ng-template>

      <markant-platform-ui-card-item
        [label]="
          'organization.details.fields.commercialRegisterId.label' | transloco
        "
        [title]="commercialRegister"
      >
        {{ commercialRegister | defaultValue: '-' }}
      </markant-platform-ui-card-item>

      <markant-seperator></markant-seperator>

      <markant-platform-ui-card-item
        [label]="'organization.details.fields.gln.label' | transloco"
        [title]="organization.gln"
      >
        {{ organization.gln | defaultValue: '-' }}
      </markant-platform-ui-card-item>
      <markant-platform-ui-card-item
        *ngIf="organization.ezrCustomer && isPlatformAdmin"
        [label]="'organization.details.fields.masterKin.label' | transloco"
        [title]="organization.masterKin"
      >
        {{ organization.masterKin | defaultValue: '-' }}
      </markant-platform-ui-card-item>
      <markant-platform-ui-card-item
        [label]="'organization.details.fields.naceCode.label' | transloco"
        [title]="organization.naceCode"
      >
        {{ organization.naceCode | defaultValue: '-' }}
      </markant-platform-ui-card-item>

      <markant-seperator></markant-seperator>

      <markant-platform-ui-card-item
        [label]="'organization.details.fields.industry.label' | transloco"
        [title]="
          organization.organizationType &&
          ('organization.details.fields.industry.' + organization.industry
            | transloco)
        "
      >
        {{
          organization.industry
            ? ('organization.details.fields.industry.' + organization.industry
              | transloco)
            : '-'
        }}
      </markant-platform-ui-card-item>
      <markant-platform-ui-card-item
        *ngIf="isPlatformAdmin"
        [label]="
          'organization.details.fields.organizationType.label' | transloco
        "
        [title]="
          organization.organizationType &&
          ('organization.details.fields.organizationType.' +
            organization.organizationType | transloco)
        "
      >
        {{
          organization.organizationType
            ? ('organization.details.fields.organizationType.' +
                organization.organizationType | transloco)
            : '-'
        }}
      </markant-platform-ui-card-item>
    </markant-platform-ui-card>
    <markant-platform-ui-card
      *ngIf="isPlatformAdmin"
      class="grid-item"
      [headline]="'organization.details.platformData' | transloco"
    >
      <markant-platform-ui-card-item
        [label]="'organization.details.fields.ezrCustomer.label' | transloco"
        [title]="
          'organization.details.fields.ezrCustomer.options.' +
            organization.ezrCustomer | transloco
        "
      >
        {{
          'organization.details.fields.ezrCustomer.options.' +
            organization.ezrCustomer | transloco
        }}
      </markant-platform-ui-card-item>
      <markant-checkbox
        *ngIf="isPlatformAdmin && organization.markantOrganization"
        class="markant-organization-checkbox"
        [checked]="true"
        [disabled]="true"
        [small]="true"
        ><span>{{
          'organization.details.fields.markantOrganization.label' | transloco
        }}</span></markant-checkbox
      >
      <markant-platform-ui-card-item
        [label]="
          'organization.details.fields.qualificationLevel.label' | transloco
        "
        [title]="
          organization.qualificationLevel &&
          ('organization.details.fields.qualificationLevel.short.' +
            organization.qualificationLevel | transloco)
        "
      >
        {{
          organization.qualificationLevel
            ? ('organization.details.fields.qualificationLevel.short.' +
                organization.qualificationLevel | transloco)
            : '-'
        }}
      </markant-platform-ui-card-item>
      <markant-platform-ui-card-item
        [label]="'organization.profile.creationDate' | transloco"
        [title]="
          organization.createdAt &&
          (organization.createdAt
            | date: 'dd MMMM yyyy' : '' : translocoService.getActiveLang())
        "
      >
        {{
          organization.createdAt
            ? (organization.createdAt
              | date: 'dd MMMM yyyy' : '' : translocoService.getActiveLang())
            : '-'
        }}
      </markant-platform-ui-card-item>
      @if (isPlatformAdmin) {
        <markant-platform-ui-card-item
          [label]="'organization.profile.leadContext' | transloco"
          [title]="organization.leadContext"
        >
          {{ organization.leadContext | defaultValue: '-' }}
        </markant-platform-ui-card-item>
      }
      <markant-platform-ui-card-item
        [label]="'organization.profile.documentsCount' | transloco"
        [title]="documentCount"
      >
        {{ documentCount ?? '-' }}
      </markant-platform-ui-card-item>
      <markant-platform-ui-card-item
        [label]="'organization.profile.membersCount' | transloco"
        [title]="userCount"
      >
        {{ userCount ?? '-' }}
      </markant-platform-ui-card-item>
    </markant-platform-ui-card>
  </div>

  <div class="grid-group">
    <div class="grid-item">
      <markant-platform-ui-card
        [headline]="'organization.details.address' | transloco"
      >
        <markant-platform-ui-card-item
          [label]="'organization.profile.address' | transloco"
          [title]="formatAddress(organization.address)"
        >
          {{ formatAddress(organization.address) | defaultValue: '-' }}
        </markant-platform-ui-card-item>
        <markant-platform-ui-card-item
          [label]="'organization.profile.country' | transloco"
          [title]="
            localeService.getLocalizedCountryName(
              organization.address.countryCode
            ) | async
          "
        >
          {{
            localeService.getLocalizedCountryName(
              organization.address.countryCode
            ) | async
          }}
        </markant-platform-ui-card-item>

        <markant-seperator></markant-seperator>

        <markant-platform-ui-card-item
          [label]="'organization.details.fields.billingEmail.label' | transloco"
          [title]="organization.billingEmail"
        >
          {{ organization.billingEmail | defaultValue: '-' }}
        </markant-platform-ui-card-item>
        <markant-platform-ui-card-item
          [label]="
            'organization.details.fields.billingLanguageIsoCode.label'
              | transloco
          "
          [title]="
            organization.billingLanguageIsoCode &&
            ('languageSelect.' +
              organization.billingLanguageIsoCode.toLowerCase() | transloco)
          "
        >
          {{
            organization.billingLanguageIsoCode
              ? ('languageSelect.' +
                  organization.billingLanguageIsoCode.toLowerCase() | transloco)
              : '-'
          }}
        </markant-platform-ui-card-item>
      </markant-platform-ui-card>
    </div>
    <div class="grid-item">
      <markant-platform-ui-card
        [headline]="'organization.details.paymentInformation' | transloco"
      >
        <markant-platform-ui-card-item
          [label]="
            'organization.details.fields.paymentInformation.iban.label'
              | transloco
          "
          [title]="organization.paymentInformation?.iban"
        >
          {{ organization.paymentInformation?.iban | defaultValue: '-' }}
        </markant-platform-ui-card-item>
        <markant-platform-ui-card-item
          [label]="
            'organization.details.fields.paymentInformation.bic.label'
              | transloco
          "
          [title]="organization.paymentInformation?.bic"
        >
          {{ organization.paymentInformation?.bic | defaultValue: '-' }}
        </markant-platform-ui-card-item>
        <markant-platform-ui-card-item
          [label]="
            'organization.details.fields.paymentInformation.bank.label'
              | transloco
          "
          [title]="organization.paymentInformation?.bank"
        >
          {{ organization.paymentInformation?.bank | defaultValue: '-' }}
        </markant-platform-ui-card-item>
      </markant-platform-ui-card>
      <markant-platform-ui-card
        [headline]="'organization.details.techData' | transloco"
      >
        <markant-platform-ui-card-item
          *ngIf="isPlatformAdmin"
          [label]="'organization.details.fields.markantId.label' | transloco"
          [title]="organization.markantId"
        >
          {{ organization.markantId | defaultValue: '-' }}
        </markant-platform-ui-card-item>
        <markant-platform-ui-card-item
          [label]="'organization.details.fields.technical.id' | transloco"
          [title]="organization.id"
        >
          {{ organization.id }}
        </markant-platform-ui-card-item>
        <markant-platform-ui-card-item
          *ngIf="isPlatformAdmin"
          [label]="
            'organization.details.fields.technical.customerNumber' | transloco
          "
          [title]="organization.customerNumber"
        >
          {{ organization.customerNumber ?? '-' }}
        </markant-platform-ui-card-item>
        <markant-platform-ui-card-item
          *ngIf="isPlatformAdmin"
          [label]="'organization.details.fields.technical.crmId' | transloco"
          [title]="organization.crmId"
        >
          {{ organization.crmId | defaultValue: '-' }}
        </markant-platform-ui-card-item>
      </markant-platform-ui-card>
    </div>
  </div>
</div>
